const AggregateWidget = ({ name, data, agg, field }) => {
  const rows = Array.isArray(data) ? data : (data?.data ?? []);
    if (!rows.length) {
      return (
        <div style={{ border: "1px solid #ccc", borderRadius: 8, boxShadow: "0 2px 5px rgba(0,0,0,0.1)", textAlign: "center",padding: 20, margin: 5 }}>
          <h3>{name}</h3>
          <h2>–</h2>
        </div>
      );
    }

  let rawValue = null;
  if (agg === "SUM") {
    const total = rows.reduce((sum, row) => sum + (row[field] ?? 0), 0);
    rawValue = `$${total.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  } else if (agg === "COUNT") {
    rawValue = field === "*" ? rows.length : rows.filter((r) => r[field] != null).length;
  } else if (agg == 'DISPLAY') {
     rawValue = rows[0]?.VALUE ?? "–";
  }

  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: 8,
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        textAlign: "center",
        backgroundColor: "#f9f9f9",
        padding: 20,
        margin: 5,
      }}
    >
      <h3 style={{ fontWeight: "bold", margin: 0 }}>{name}</h3>
      <h2 style={{ fontWeight: "bold", margin: 10, color: "#FF9800" }}>
        {rawValue}
      </h2>
    </div>
  );
};

export default AggregateWidget;
